import React from 'react';

const ProgressSteps = ({ currentStep }) => {
  const steps = ['Vehicle', 'Extras', 'Passenger', 'Payment'];
  
  return (
    <nav className="mb-8 w-full max-w-5xl mx-auto px-4" aria-label="Booking progress">
      {/* Desktop Step Bar */}
      <div className="hidden md:block glass-panel rounded-3xl border-white/10 bg-gradient-to-r from-[#0d1320]/80 to-[#0d1320]/60 p-4 backdrop-blur-3xl shadow-2xl">
        <ol className="flex items-center justify-between list-none m-0 p-0">
          {steps.map((step, index) => {
            const isDone = index < currentStep;
            const isActive = index === currentStep;
            const isFuture = index > currentStep;

            return (
              <li key={step} className="flex-1 flex items-center last:flex-none">
                <div className="flex items-center gap-3">
                  <div className={`
                    flex items-center justify-center rounded-full font-bold transition-all duration-500
                    ${isActive ? 'w-9 h-9 text-sm bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-[0_0_20px_rgba(59,130,246,0.4)]' : ''}
                    ${isDone ? 'w-8 h-8 text-xs bg-green-500/15 text-green-500 border border-green-500/20' : ''}
                    ${isFuture ? 'w-8 h-8 text-xs bg-white/5 text-white/95 border border-white/10' : ''}
                  `}>
                    {isDone ? (
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    ) : (
                      index + 1
                    )}
                  </div>
                  <span className={`
                    font-mono text-[10px] uppercase tracking-[0.18em] transition-colors duration-500
                    ${isActive ? 'text-white font-bold' : ''}
                    ${isDone ? 'text-green-500' : ''}
                    ${isFuture ? 'text-white/95' : ''}
                  `}>
                    {step}
                  </span>
                </div>
                
                {index < steps.length - 1 && (
                  <div className={`flex-1 mx-4 h-[2px] rounded-full transition-all duration-700 ${
                    isDone ? 'bg-green-500' : 
                    isActive ? 'bg-gradient-to-r from-blue-500/40 to-white/5' : 'border-t border-dashed border-white/10'
                  }`} />
                )}
              </li>
            );
          })}
        </ol>
      </div>

      {/* Mobile Step Bar */}
      <div className="md:hidden glass-panel rounded-2xl border-white/10 bg-[#0d1320]/80 p-4 backdrop-blur-2xl flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold text-sm shadow-[0_0_20px_rgba(59,130,246,0.4)]">
            {currentStep + 1}
          </div>
          <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-white font-bold">
            {steps[currentStep]}
          </span>
        </div>
        
        <div className="flex gap-1.5 items-center">
          {steps.map((_, index) => (
            <div 
              key={index} 
              className={`h-1.5 rounded-full transition-all duration-300 ${
                index === currentStep ? 'w-5 bg-gradient-to-r from-blue-500 to-blue-600' :
                index < currentStep ? 'w-1.5 bg-green-500' : 'w-1.5 bg-white/15'
              }`} 
            />
          ))}
        </div>
      </div>
    </nav>
  );
};

export default ProgressSteps;